// ** Reducers Imports
import layout from './layout'
import navbar from './navbar'

const rootReducer = {
  layout,
  navbar
}

export default rootReducer
